export function sanitizeLinks(links) {
  return links.map(link => {
    const {href, ...sanitized} = link;
    if (!href) {
      return sanitized;
    }
    // can't use the URL constructor with URL templates (e.g. for tiles)
    const parts = href.split('?');
    if (parts.length !== 2) {
      sanitized.href = href;
      return sanitized;
    }
    const params = new URLSearchParams(parts[1]);
    if (!params.has('api_key')) {
      sanitized.href = href;
      return sanitized;
    }
    params.delete('api_key');
    if (params.size === 0) {
      sanitized.href = parts[0];
      return sanitized;
    }
    sanitized.href = parts[0] + '?' + params.toString();
    return sanitized;
  });
}
